export const environment = {
  production: false,
  name: 'develop',
  apiUrl: 'https://api.desenvolvimento.liv635.com.br/v1',
  cloudFrontDomain: 'https://cdn.desenvolvimento.liv635.com.br',
  gallery: {
    image: {
      minWidth: 800,
      minHeight: 600,
      maxSizeMB: 10,
    },
    video: {
      maxSizeMB: 50,
    },
    webpQuality: 0.9,
  },
  appointment: {
    startHour: 10,
    mondayToThursdayStartHour: 8,
    endHour: 17,
    fridayEndHour: 16,
    saturdayEndHour: 13,
    minDate: '2026-03-13',
  },
  company: {
    email: 'contato@akavan.com.br',
    phone: '+5561992898079',
    phoneFormatted: '+55 (61) 99289-8079',
    cnpj: '63.822.189/0001-18',
    whatsappUrl: 'https://wa.me/5561992898079?text=Olá%2C%20tenho%20interesse%20em%20saber%20mais%20sobre%20os%20imóveis%20disponíveis.',
    instagramUrl: 'https://www.instagram.com/liv.635/',
  },
};
